import React from 'react';
export default () => <div className="type undefined">undefined</div>;



// WEBPACK FOOTER //
// ./src/components/types/UndefinedType.js